export enum ColumnType {
  isActive = "isActive",
  name = "name",
  householdMembersCount = "householdMembersCount",
  enableTime = "enableTime",
  previousWaste = "previousWaste",
  currentWaste = "currentWaste",
  amount = "amount",
  netAmount = "netAmount",
  realAmount = "realAmount",
  balance = "balance",
  isPaid = "isPaid",
  paymentType = "paymentType",
}

export const columnLabelsCalculation: ColumnType[] = [
  ColumnType.isActive,
  ColumnType.name,
  ColumnType.householdMembersCount,
  ColumnType.enableTime,
  ColumnType.previousWaste,
  ColumnType.amount,
  ColumnType.paymentType,
];

export const columnLabelsBilling: ColumnType[] = [
  ColumnType.isActive,
  ColumnType.name,
  ColumnType.householdMembersCount,
  ColumnType.enableTime,
  ColumnType.currentWaste,
  ColumnType.netAmount,
  ColumnType.realAmount,
  ColumnType.balance,
  ColumnType.isPaid,
];
